import { PHASE_LABELS, PHASES } from "@/lib/format";

/** Phase is ordinary progress: plain text, no decorative colour. */
export const PhaseBadge = ({ phase, className = "" }) => (
  <span className={`phase-label ${className}`} data-testid={`phase-badge-${phase}`}>{PHASE_LABELS[phase] || phase}</span>
);

export const TONES = {
  waiting: "var(--state-waiting)",
  ready: "var(--state-ready)",
  released: "var(--state-released)",
  rest: "var(--state-rest)",
  neutral: "var(--state-neutral)",
  ok: "var(--state-released)",
};

export const toneVar = (tone) => TONES[tone] || TONES.neutral;

/** Status as readable text with a tone dot. `strong` keeps full foreground colour. */
export const StateChip = ({ tone = "neutral", children, className = "", testId, dot = true, strong = false }) => (
  <span className={`state-text ${strong ? "is-strong" : "text-muted-foreground"} ${className}`} style={{ "--chip": toneVar(tone) }} data-testid={testId}>
    {dot && <span className="dot" aria-hidden="true" />}{children}
  </span>
);

export const toneForNextAction = (kind) => ({ handling: "ready", venter: "waiting", blokker: "rest", info: "neutral" }[kind] || "neutral");
export const toneForSpecStatus = (s) => ({ frigitt: "released", kundegodkjent: "ready", til_kundegodkjenning: "waiting", utkast: "neutral", erstattet: "neutral", avvist: "rest" }[s] || "neutral");
export const toneForDrawingStatus = (s) => ({ gjeldende: "released", kundegodkjent: "ready", til_godkjenning: "waiting", utkast: "neutral", erstattet: "neutral", avvist: "rest" }[s] || "neutral");
export const toneForServiceStatus = (s) => ({ apen: "waiting", planlagt: "ready", utfort: "released", lukket: "neutral" }[s] || "neutral");
export const toneForChangeStatus = (s) => ({ registrert: "ready", vurdert: "ready", grunnlag_oppdatert: "ready", til_kundegodkjenning: "waiting", kundegodkjent: "ready", endring_onsket: "rest", frigitt: "released", avvist: "neutral" }[s] || "neutral");
export const toneForInstallStatus = (s) => ({ montert: "released", montert_med_restpunkter: "waiting", pagar: "ready", planlagt: "neutral", ikke_planlagt: "neutral" }[s] || "neutral");

export const initials = (name = "") => name.split(/\s+/).filter(Boolean).slice(0, 2).map((p) => p[0]?.toUpperCase()).join("") || "?";

export const Avatar = ({ name, size = "sm", className = "" }) => {
  const sz = { xs: "h-6 w-6 text-[10px]", sm: "h-7 w-7 text-[11px]", md: "h-9 w-9 text-xs", lg: "h-11 w-11 text-sm" }[size];
  return <span className={`avatar-initials ${sz} ${className}`} title={name} aria-hidden="true">{initials(name)}</span>;
};

/** Slim lifecycle line: Forespørsel → … → Levert. Shows actual phase; it is not a control. */
export const PhaseRail = ({ phase, compact = false, className = "" }) => {
  const idx = PHASES.indexOf(phase);
  return (
    <ol className={`phase-line ${className}`} data-testid="phase-rail" aria-label="Livssyklus">
      {PHASES.map((p, i) => {
        const state = i < idx ? "done" : i === idx ? "current" : "todo";
        return (
          <li key={p} data-state={state} data-testid={`phase-rail-${p}`} aria-current={state === "current" ? "step" : undefined}>
            <span className="bar" />
            <span className={`lbl ${compact && state !== "current" ? "hidden sm:block" : ""}`}>{PHASE_LABELS[p]}</span>
          </li>
        );
      })}
    </ol>
  );
};
